module.exports = __webpack_public_path__ + "static/kids_friendly_city-7e744405e4d7373dfe88872b7cb614de.png";